import React, { lazy, Suspense } from 'react';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';

const LogIn = lazy(() => import('@stb-module-auth/screens/LogIn'));

export default function AuthNavigation() {
  return (
    <HashRouter>
      <Suspense fallback={<React.Fragment />}>
        <Switch>
          <Route path="/log-in">
            <LogIn />
          </Route>
          <Redirect from="/" to="/log-in" />
        </Switch>
      </Suspense>
    </HashRouter>
  );
}
